import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-services-enterprises',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './services-enterprises.component.html',
  styleUrl: './services-enterprises.component.css'
})
export class ServicesEnterprisesComponent {

}
